/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  Fields,
  FieldsVariables,
  Fields_fields_Fields_results_Field as Field,
} from './types/index.graphql'

export const FIELDS = gql`
  query Fields($companyId: Int!) {
    fields(companyId: $companyId) {
      results {
        id
        name
        directions
        location {
          type
          coordinates
        }
      }
    }
  }
`
